import React from "react";
import Icon from "../Icon/Icon.component";
import {
  CardBody,
  CardFoot,
  CardName,
  CardQuote,
  CardRole,
  CardTopline,
  CardWrapper,
} from "./CustomerCard.styled";

interface ICustomerCard {
  name: string;
  role: string;
  quote: string;
  linkedinUrl: string;
  linkedinLabel: string;
}

const CustomerCard = ({
  name,
  role,
  quote,
  linkedinUrl,
  linkedinLabel,
}: ICustomerCard) => (
  <CardWrapper>
    <CardBody>
      <CardTopline>
        <CardName>{name}</CardName>
      </CardTopline>
      <CardQuote>“{quote}”</CardQuote>
      <CardRole>{role}</CardRole>
    </CardBody>
    <CardFoot
      as="a"
      href={linkedinUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Icon name="linkedin" />
      <span>{linkedinLabel}</span>
    </CardFoot>
  </CardWrapper>
);

export default CustomerCard;
